import React from "react"

const RatingIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
    >
      <g clipPath="url(#clip0_14363_26145)">
        <path
          d="M4.19587 6.74486C4.07525 6.66859 3.924 6.6686 3.80338 6.74489L1.95347 7.91488C1.66674 8.09622 1.31228 7.82791 1.38847 7.4872L1.87891 5.29404C1.91077 5.15156 1.86457 5.00238 1.75884 4.90629L0.130505 3.42661C-0.121722 3.1974 0.0138716 2.76448 0.347135 2.73495L2.49304 2.5448C2.63278 2.53242 2.75451 2.44046 2.80942 2.3058L3.65158 0.240419C3.78229 -0.0801398 4.21771 -0.0801394 4.34842 0.240419L5.19058 2.3058C5.24549 2.44046 5.36722 2.53242 5.50696 2.5448L7.65287 2.73495C7.98613 2.76448 8.12172 3.1974 7.8695 3.42661L6.24116 4.90629C6.13543 5.00238 6.08923 5.15156 6.12109 5.29404L6.61156 7.48735C6.68775 7.82804 6.33333 8.09635 6.0466 7.91505L4.19587 6.74486Z"
          fill="#F7BA1E"
        />
      </g>
      <defs>
        <clipPath id="clip0_14363_26145">
          <rect width="8" height="8" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default RatingIcon
